import React, { useState, useCallback, useEffect } from "react";
import { Grid } from "@mui/material";
import Sidebar from "./filter";
import ClientList from "./list";
import ordersApi from "../../services/orders";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/snackbar/actions";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../utils";
function Manage_Products() {
  const dispatch = useDispatch();
  const ProductId = getDecryptedCookie("id");
  const [searchparams, setSearchparams] = useState({});
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [subscriberData, setSubscriberData] = useState({});

  const fetchSubscribers = useCallback(async () => {
    dispatch(showLoader());
    try {
      const response = await ordersApi.getAllOrders(
        paginationModel.page + 1,
        paginationModel.pageSize,
        searchparams
      );

      const responseData = response?.data?.data;
      if (responseData) {
        setSubscriberData(responseData);
        setRowCount(responseData.pagination.totalItems);
      } else {
        console.warn("Unexpected response format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching pricing:", error);
    } finally {
      dispatch(hideLoader());
    }
  }, [paginationModel.page, paginationModel.pageSize, searchparams, dispatch]);

  useEffect(() => {
    fetchSubscribers();
  }, [fetchSubscribers]);

  return (
    <Grid container spacing={3} mt={2}>
      <Grid item xs={12} sm={12} md={3}>
        <Sidebar
          setSearchparams={setSearchparams}
          searchparams={searchparams}
          subscriberData={subscriberData}
          fetchSubscribers={fetchSubscribers}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={9}>
        <ClientList
          subscriberData={subscriberData}
          rowCount={rowCount}
          searchparams={searchparams}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </Grid>
    </Grid>
  );
}
export default Manage_Products;
